/**
 * Personal / profile data used in the in-world UI dialogs.
 * Update this file to change any displayed contact or bio information.
 */

export const PROFILE_CONFIG = {
  /** Displayed in the workspace dialog header */
  title: "Senior Software & DevOps Engineer",

  bio: [
    "With a focus on bridging the gap between robust backend architecture and scalable cloud infrastructure. I specialise in engineering resilient, high-performance systems and automating complex workflows through robust CI/CD pipelines to ensure operational excellence.",
    "Currently contributing to the engineering team at <b style=\"color:#fff;\">Giftbee</b>, Australia, I prioritise system reliability and optimised performance as the foundation of every deployment.",
    "This little island? Just one of those side projects that got out of hand.",
  ],

  contact: {
    email: {
      display: "hi@lasantha.dev",
      href: "mailto:hi@lasantha.dev",
    },
    linkedin: {
      display: "linkedin.com/in/lasantha-sudeera",
      href: "https://www.linkedin.com/in/lasantha-sudeera/",
    },
    github: {
      display: "github.com/LasanthaSudeera",
      href: "https://github.com/LasanthaSudeera",
    },
  },
};
